export default ({ $config }, inject) => {
  inject('features', $config.features);
};
